import { useMemo } from "react"

import type { PortalMark } from "./portal-instances"
import { sortedPortalMarks } from "./portal-instances"
import { useZeroWorkspace } from "./zero"

/**
 * Every portal a thread can carry, main portal first. Empty when the workspace
 * runs a single portal, which is what every caller gates its UI on.
 */
export function usePortalMarks(): PortalMark[] {
	const workspace = useZeroWorkspace()
	const instances = workspace?.portalInstances

	return useMemo(() => sortedPortalMarks(instances ?? []), [instances])
}

export function usePortalMarkById(): Map<string, PortalMark> {
	const marks = usePortalMarks()
	return useMemo(() => {
		const map = new Map<string, PortalMark>()
		for (const mark of marks) {
			if (mark.id) map.set(mark.id, mark)
		}
		return map
	}, [marks])
}
